import React from 'react';
import { observer } from 'mobx-react';
import { useIntl } from 'react-intl';
import Dropzone from 'react-dropzone';

import DragAndDrop from 'components/DragAndDrop/DragAndDrop';
import messages from '../messages';
import { useStores } from '../../../store/useStores';

const dropZoneStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: '270px'
};

function AnalyseDropZone({ onDrop, canDrop }) {
  const intl = useIntl();
  const {
    fileUploadStore: { currentFileUpload, totalFileUpload, uploadProgress }
  } = useStores();

  return (
    <Dropzone
      style={dropZoneStyle}
      accept="video/*,video/mp4,video/mov"
      onDrop={onDrop}
      disabled={!canDrop}
    >
      {({ isDragActive, isDragReject }) => {
        let dropState = 'default';
        let progressLabel = intl.formatMessage(
          messages.analyseOverviewVideoUploadDefault
        );
        if (isDragActive) {
          dropState = 'isDragActive';
          progressLabel = intl.formatMessage(
            messages.analyseOverviewVideoUploadActive
          );
        }
        if (isDragReject) {
          dropState = 'isDragReject';
          progressLabel = intl.formatMessage(
            messages.analyseOverviewVideoUploadReject
          );
        }
        if (!canDrop) {
          dropState = 'acceptedFiles';
          progressLabel = intl.formatMessage(
            messages.analyseOverviewVideoUploadProgress,
            {
              progress: `${currentFileUpload}/${totalFileUpload}`
            }
          );
        }
        return (
          <DragAndDrop
            status={dropState}
            calcPercent={Math.round(uploadProgress * 100)}
            progressLabel={progressLabel}
          />
        );
      }}
    </Dropzone>
  );
}

export default observer(AnalyseDropZone);
